import { Button, Flex, StackDivider, useDisclosure, VStack } from "@chakra-ui/react"
import { PlusCircle } from "@phosphor-icons/react"
import Note from "./Note"
import AddNote from "./AddNote";

const Notes = () => {
	const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<Flex w="full" justifyContent="center" alignItems="center" direction="column">
			<AddNote isOpen={isOpen} onClose={onClose} />
			<Button colorScheme="green" leftIcon={<PlusCircle size="22" />} onClick={onOpen}>
				Adicionar Nota
			</Button>
			<VStack mt="8" spacing="6" w="full" divider={<StackDivider w="full" />}>
				<Note />
				<Note />
				<Note />
				<Note />
			</VStack>
		</Flex>
	)
}

export default Notes
